module.exports = __webpack_public_path__ + "img/222A4605.85127cc1.png";